export default {"src":"/_next/static/media/UnAcceptableIcon.cc450d8e.svg","height":18,"width":17,"blurWidth":0,"blurHeight":0};